'use strict';
const mmWidgets = require('../widgets/mm-widgets');
mmWidgets.fn.stickerEmojiWidget = function (params) {
	const {stickersEditorModel, sticker, action} = params;
	if (!action || !stickersEditorModel || !stickersEditorModel[action] || typeof stickersEditorModel[action] !== 'function' || !sticker || !sticker.codepoint) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const {stickersEditorModel, sticker} = params,
			widget = this,
			codepointArray = sticker && sticker.codepoint && sticker.codepoint.split(' ').map(x => parseInt(x, 16)),
			emoji = codepointArray && String.fromCodePoint.apply(String, codepointArray);
		widget.text(emoji).attr('data-mm-codepoint', codepointArray.join(',')).click(function () {
			stickersEditorModel[action](sticker);
		});
	});
};
